//Manage service bus notifications
import {mapActions,mapState,mapGetters} from 'vuex' 
const { ServiceBusClient, delay } = require("@azure/service-bus");
const sbClient = new ServiceBusClient("Endpoint=sb://misweb1.servicebus.windows.net/;SharedAccessKeyName=misweb1_listen;SharedAccessKey=C5UiG84WYZuUCyUWKu9usRz3NsF8bm7eCxlgxV34UX0=;EntityPath=misweb1_topic");
var receiver;
// import { mapState } from "vuex";

export const validate = {
  ...mapActions(["loadNotifications"]),
  //...mapState(['user']),

  data() {
    return {
      validHash: {},
      sendingToServer: false,
      hasBeenSubmitted: false,
      invalidFields: 0,
      phoneRx: /^([0-9 ().+_-]+)$/,
      emailRx: /(?=^((?!\.@).)*$)(^[\w.%+->]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,10}$)/,
      // emailRx: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      errMsgs: {
        // required: "This field is required",
        numbersOnly: "Numbers only please",
        noNumbers: "No Numbers allowed"
      }    
    };
  },
  watch: {
    validHash: {
      deep: true,
      handler() {
        this.updateInvalidFields();
      }
    }
  },
  methods: 
  {
    localize(str) {
      //alert("loclize1");
      //alert("this.localizedUI="+this.localizedUI.length);
      //if (!this.localizedUIReady) {return null;}
      let tagText = str.toLowerCase().replace(/(\s|-)/g, "_");

      //let obj = _.find(this.localizedUI, { tag });
      let obj = _.find(this.localizedUI, {tag:tagText});

      if (obj) {
        return obj.title;
      }
      return str;
    },  





    //-------------------------------------------------------
    //////////
    ////////////////////
    //////////////////////////////
    //////////////////////////////////////////////////
    //
    //  NOTIFICATIONS METHODS 
    //////
    ////
    //////////
    //////////
    ///////////////
    ////////////////////
    //////////////////////////////
    //-------------------------------------------------------
    async sbClientStartListen()        
    {
        return false;
        
        var vm = this;
        if(this.user==null){return false;}

        var _subscriptionName="user_"+this.user.userID;
        console.log("sbClientStartListen STARTED");
        console.log("start listen to "+_subscriptionName);
        receiver = sbClient.createReceiver("misweb1_topic",_subscriptionName);
        const myMessageHandler = async (messageReceived) => 
        {
            //alert("Received message:"+messageReceived.body );
            console.log(`Received message: ${messageReceived.body}`);
            vm.loadNotifications();//<<RELOAD NOTIFICATIONS
        };
        const myErrorHandler = async (error) => 
        {
            console.log(error);
        };
        receiver.subscribe({
            processMessage: myMessageHandler,
            processError: myErrorHandler
        });
        // Waiting long enough before closing the sender to send messages

        await delay(100000);//100 seconds
        //await delay(5000000); //83 minutes
        await receiver.close();	
        await sbClient.close();
        this.sbClientStartListen();//restart 
    },
    //NOTIFICATIONS METHODS //-------------------------------
    //-------------------------------------------------------

    updateInvalidFields() {
      this.$set(
        this,
        "invalidFields",
        _.reject(_.map(this.validHash, b => b)).length
      );
    },
    updateValidHash(id, valid) {
      console.log("update valid HASH > ", id, " :: ", valid);

      if (!id) {
        this.$set(this, "validHash", {});
      } else {
        this.$set(this.validHash, id, valid);
      }
    },
    removeFromValidHash(id) {
      // console.log("REMOVE FROM HASH > ", id);
      delete this.validHash[id];
      this.updateInvalidFields();
    },
    clearValidHash() {
      // console.log("REMOVE FROM HASH > ", id);
      this.validHash = {};
      this.updateInvalidFields();
    },
    validAlpha(_string) {
      return /^[a-z]+$/i.test(_string);
    },
    validNumbers(_string) {
      return /^[0-9]+$/i.test(_string);
    },
    // validNumbers(_string) {
    //   return /^[0-9]+$/i.test(_string);
    // },
    validAlphaNumbers(_string) {
      return /^[a-z0-9]{2,20}$/i.test(_string);
    },
    validUSZipcode(_string) {
      return /^\d{5}(-\d{4})?$/.test(_string);
    },
    validCAZipcode(_string) {
      return /^[ABCEGHJKLMNPRSTVXY]\d[A-Z] ?\d[A-Z]\d$/.test(_string);
    },
    validPhoneNumber(string) {
      return /^([0-9 ().+_-]{8,16})$/.test(string);
    },
    validUsCaPhoneNumber(string) {
      return /^\D*1?\D*([2-9][0-8][0-9])\D*([2-9][0-9][0-9])\D*([0-9][0-9][0-9][0-9])(( |:|x|ext|X|EXT)\D*(\d{1,6}))?$/.test(
        string
      );
    }
  },
  computed: {
    ...mapState(["localizedUI", "localizedUIReady","user"]),
    // validationPassed() {
    //   let trig = this.validateTrigger;
    //   console.log("cehckvalid > ", trig);
    //   return !_.reject(this.validHash).length;
    // },
    formIsValid() {
      // if (this.hasBeenSubmitted) {
      return this.invalidFields === 0;
      // }
      // return false;
    }
  }
};
